import React from 'react';

const CSSIcon = () => {
  return <img src='/skill-icons/css.png' alt='css-logo' />;
};

export default CSSIcon;
